<template>
  <div class="mx-10 ma-5">
    <v-card
      class="pa-5"
      :style="{ border: '1px solid var(--primary-boarder-color)' }"
    >
      <div>
        <PageTitleWithSearch
          :title="'Roles'"
          :btnName="'Add New Role'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/roles/create'"
          :btnPermission="'customer.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <v-data-table
          v-if="roles"
          :headers="headers"
          :items="roles"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.name }}</td>
              <td class="text-center">
                <v-btn
                  class="mx-2"
                  color="#FFE0B2"
                  :to="'/roles/edit/' + item.name"
                  fab
                  small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800"> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  small
                  color="#FFCDD2"
                  @click="dropRoleConfirm(item.name)"
                  fab
                  style="box-shadow: none;"
                >
                  <v-icon dark small color="#F44336">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-row class="my-1">
        <Pagination
          v-model="page"
          :loading="loading"
          :total="total"
          :page="page"
        ></Pagination>
      </v-row>
    </v-card>

    <ConfirmModal
      :text="'Do you want to drop this role?'"
      :title="'Drop Role'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Pagination from "@/components/shared/Pagination";
import Snackbars from "@/components/shared/Snackbars";
import ConfirmModal from "@/components/shared/ConfirmModal";
import { RoleService } from "@/services/role-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "RolesGrid",
  components: { PageTitleWithSearch, Pagination, Snackbars, ConfirmModal },
  data: function() {
    return {
      roles: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalRole: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "",
      defaultImage: require("@/assets/img/avatar.svg"),
      skill: 20,
      headers: [
        { text: "Role Name", value: "role_name", align: "left" },
        { text: "Actions", value: "action", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getRoleList();
  },

  watch: {
    search() {
      this.page = 1;
      this.getRoleList();
    },
    page() {
      this.getRoleList();
    },
  },

  methods: {
    getRoleList() {
      this.loading = true;
      RoleService.getRoleList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.roles = response.data.data;

            this.total = response.data.meta.last_page || 0;
            this.totalRole = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    searchChange(value) {
      this.search = value;
    },

    dropRoleConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropRole();
    },

    dropRole() {},

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
